/**
 * Constants for step node component
 * Node styling and interaction configuration
 */

export const STEP_NODE_CONSTANTS = {
  // Dimensions
  SIZE: 8, // theme.spacing units for width and height
  BORDER_RADIUS: '50%',

  // Typography
  FONT_SIZE: 14, // px
  FONT_WEIGHT: 'bold' as const,

  // Icon
  ICON_SIZE: 4, // theme.spacing units

  // Z-Index
  Z_INDEX: 20, // Very high z-index to ensure nodes are always on top of progress lines

  // Animations & Transitions
  TRANSITION: {
    DURATION: '0.4s',
    EASING: 'cubic-bezier(0.4, 0, 0.2, 1)',
    PROPERTIES: 'all',
  },

  // Completion Animation
  COMPLETION_ANIMATION: {
    DURATION: '0.8s',
    DELAY: '0.2s', // Start very soon to be visible
    EASING: 'cubic-bezier(0.4, 0, 0.2, 1)',
    SCALE_UP: 1.4, // More dramatic scale for visibility
    SCALE_DOWN: 1.0,
  },

  // Hover Effects
  HOVER: {
    SCALE: 1.05,
  },

  // Transform Origin
  TRANSFORM_ORIGIN: 'center',

  // SVG Override Priority
  SVG_OVERRIDE_PRIORITY: '!important',
} as const;
